import { approvalActions } from './slice';
import { Action } from 'redux-saga';
import { UpdateApprovalProjectsPayload } from './types';

export const fetchApprovalProjects = approvalActions.fetchProjects as (
  countries: string[],
) => Action;
export const updateApprovalProjects = approvalActions.updateProjects as (
  payload: UpdateApprovalProjectsPayload,
) => Action;
export const setSelectedProjectId = approvalActions.setSelectedProjectId as (
  projectId: string,
) => Action;

export const fetchApprovalProject = approvalActions.fetchApprovalProject as (
  projectId: string,
) => Action;

export const fetchApprovalProjectSuccess =
  approvalActions.fetchApprovalProjectSuccess as (data?: unknown) => Action;
export const captureRevisedBudget =
  approvalActions.captureRevisedBudget as (payload: {
    projectIds: string[];
    fiscalYear: string;
  }) => Action;
